import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

import { Link } from 'react-router-dom';

import { Button } from './ui/button';

import Card from './Card';
import SimpleCurl from './SimpleCurl';
import UserMessages from './UserMessages';
import useCurrentUser from './useCurrentUser';

let Home = ({ viewer }) => {
  const hasDevice = viewer.devices.edges.length > 0;
  const [currentUser] = useCurrentUser();

  return (
    <div className="grid grid-cols-12 gap-6">
      {viewer.subscribed === 'limited' && viewer.messageCount >= 1 && (
        <div className="col-span-12 sm:col-span-6">
          <Card className="border-orange-200 bg-gradient-to-br from-orange-50 to-white">
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center">
                <svg className="w-5 h-5 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-gray-900 mb-1">Message Limit</h3>
                <p className="text-sm text-gray-600 mb-3">
                  You've used {viewer.messageCount} of your {viewer.freeLimit} free messages.
                </p>
                <Button asChild size="sm">
                  <Link to="/subscribe">Upgrade now</Link>
                </Button>
              </div>
            </div>
          </Card>
        </div>
      )}
      {(!hasDevice || currentUser.isAnonymous) && (
        <div className="col-span-12 sm:col-span-6">
          <Card className="border-blue-200 bg-gradient-to-br from-blue-50 to-white">
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-gray-900 mb-1">Setup Required</h3>
                <p className="text-sm text-gray-600 mb-3">Finish setting up your account and devices</p>
                <Button asChild size="sm">
                  <Link to="/finish_setup">Finish setup</Link>
                </Button>
              </div>
            </div>
          </Card>
        </div>
      )}
      <div className="col-span-12">
        <Card>
          <div className="flex items-center gap-2 mb-6">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
              <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
            </div>
            <h2 className="text-2xl font-semibold text-gray-900">Send Notification</h2>
          </div>
          <SimpleCurl accessToken={viewer.accessToken.secret} id={viewer.id} />
        </Card>
      </div>
      <div className="col-span-12">
        <UserMessages viewer={viewer} />
      </div>
    </div>
  );
};

Home = createFragmentContainer(Home, {
  viewer: graphql`
    fragment Home_viewer on User {
      id
      email
      messageCount
      freeLimit
      subscribed
      accessToken {
        secret
      }
      ...Profile_viewer
      ...UserMessages_viewer
      devices(first: 100) @connection(key: "Home_devices") {
        edges {
          node {
            id
          }
        }
      }
    }
  `,
});

export default Home;
